import React from 'react';
import ReactAccountSellerList from '../../../views/account/seller/list/ReactAccountSellerList';
import FullscreenLoader from '../../../components/base/FullscreenLoader';
import useReactTable from '../../../hooks/common/useReactTable';
import {
  ACCOUNT_SELLER_LIST_FILTER_OPTION_MODEL,
  ACCOUNT_SELLER_LIST_SORT_OPTION_MODEL,
  ACCOUNT_SELLER_LIST_SORT_PAGINATION_MODEL,
} from '../../../views/account/seller/common/constants';
import useSellersQuery from '../../../hooks/queries/account/useSellersQuery';
import { message } from 'antd';
import { hasHyphen, removeNull } from '../../../lib/utils';
import useSellerListExcelDownload from '../../../hooks/queries/account/useSellerListExcelDownload';

const AccountSellerListContainer = () => {
  const {
    filterOption,
    paginationOption,
    sortOption,
    handleChangeFilterOption,
    handleChangePaginationOption,
    handleClickSortOption,
    handleClickResetFilter,
    currentPage,
    setCurrentPage,
  } = useReactTable({
    filterOptionModel: ACCOUNT_SELLER_LIST_FILTER_OPTION_MODEL,
    sortOptionModel: ACCOUNT_SELLER_LIST_SORT_OPTION_MODEL,
    paginationModel: ACCOUNT_SELLER_LIST_SORT_PAGINATION_MODEL,
  });

  // 클라이언트를 기반으로 패칭해온 리스트 서버 상태
  const { data: accountSellerList, isLoading } = useSellersQuery(
    {
      page: Math.max(paginationOption.pageIndex, 1),
      pageSize: Math.max(paginationOption.pageSize, 100),
      sort: sortOption.sort === 'storeId' ? 'id' : '-id',
      ...filterOption,
    },
    {
      onError: (error) => {
        message.error(error.message);
        history.push('/account/seller/list?pageIndex=1&pageSize=100&sort=-id');
      },
      keepPreviousData: true,
    },
  );

  const { mutate: handleSellerListMutate } = useSellerListExcelDownload({
    data: {
      filterOption: removeNull(filterOption),
      sortOption: [{ id: 'createDate', desc: hasHyphen(sortOption.sort) }],
    },
  });

  if (isLoading) {
    return <FullscreenLoader visible={true} />;
  }

  if (!accountSellerList) {
    return null;
  }

  return (
    <ReactAccountSellerList
      accountSellerList={accountSellerList}
      onClickSortOption={handleClickSortOption}
      onChangeFilterOption={handleChangeFilterOption}
      onClickResetFilter={handleClickResetFilter}
      onChangePaginationOption={handleChangePaginationOption}
      onClickSellerListDownload={handleSellerListMutate}
      paginationOption={paginationOption}
      sortOption={sortOption}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
    />
  );
};

export default AccountSellerListContainer;
